
import Vue from 'vue'
import Component from "vue-class-component";
import {namespace} from "vuex-class";
import {Prop, Watch} from "vue-property-decorator";
import {EOrderStatuses, IOrder} from "@/model/Order/orderInterfaces";
import {BetterDataTableHeader} from "@/model/betterVuetifyInterfaces";
import {BoListPanel, BoPanel} from "bonomo/dist";

import LockerChip from "@/components/shared/chips/LockerChip.vue";
import LockerStatusChip from "@/components/shared/chips/LockerStatusChip.vue";
import OrderChip from "@/components/shared/chips/OrderChip.vue";
import UserChip from "@/components/shared/chips/UserChip.vue"
import ServiceProviderChip from "@/components/shared/chips/ServiceProviderChip.vue"
import Datim from "@/components/shared/Datim.vue";
import CreateButton from "@/components/shared/CreateButton.vue";
import { IShortLocker } from '@/model/shortInterfaces';
import { IShortCommunity } from '@/model/Community/communityInterfaces';
import {OrderHelper} from "@/helpers/OrderHelper";
import {PermissionHelper} from "@/helpers/PermissionHelper";
import {IShortServiceProvider} from "@/model/shortInterfaces";
import { DateHelper } from '@/helpers/DateHelper';
import OrderSearch from "@/components/order/widget/OrderSearch.vue";
import LockerSearch from "@/components/locker/widget/LockerSearch.vue";
import CommunitySearch from "@/components/community/widget/CommunitySearch.vue";
import CsvDownloader from "@/components/shared/CsvDownloader.vue";
import PaginationBar from "@/components/shared/PaginationBar.vue";
import OrderStatsDashboard from "@/components/order/order/OrderStatsDashboard.vue";
import {orderService} from "@/services/orderService";
import {IChipStyle} from "@/model/chipStyleInterfaces";
import {IAuthUserData, IAuthUserPermission} from "@/store/modules/authModule";
import {EUserPermissions} from "@/model/EUserPermissions";
import {EPermissionActions} from "@/model/EPermissionActions";
import {
  PAGINATION_DEFAULT_PER_PAGE,
  PAGINATION_PER_PAGE_OPTIONS,
  PAGINATION_FIRST_PAGE
} from '@/constants/pagination';
const orderModule = namespace("orderModule");
const lockerModule = namespace("lockerModule");
const communityModule = namespace("communityModule");
const serviceProviderModule = namespace("serviceProviderModule");
const authModule = namespace("authModule");

enum valueDateType {
  '-' = '-',
  active_from = 'active_from',
  created_at = 'created_at',
  due = 'due',
}

const awaitingDelivery = [
  "status_order_awaiting_collect",
  "status_order_in_route_collect",
  "status_order_sp_collected",
];

const payable = [
  "status_payment_unpaid",
  "status_payment_unpaid_invoice",
];

const orderCompletedReadyDelivery = [
  "status_order_in_route_delivery",
  "status_order_in_progress",
  "status_order_sp_delivered",
];

const withoutPackage = [
  "locker_order",
  "laundry_drop_go",
  "home_delivery",
  "bizcocho_order",
  "amazon_return",
  "custom",
  "office_order",
  "drop_only",
];

const futureOrders =  DateHelper.dateTimeFormat(Date()).slice(0, -6);
const ALL_LOCKERS_ID = 0;
const ALL_COMMUNITIES_ID = 0;


type filter = {
  status: string[],
  channel: string[],
  type: string[],
  grandTotalMin: number|null,
  grandTotalMax: number|null,
  serviceProviderId: number,
  paymentStatus: string[],
  confirmed: boolean|number,
  lockerId: number,
  communityId: number,
  rentback: boolean,
  discountCode: boolean,
  inLockerOver24h: boolean,
  inLockerOver72h: boolean,
};

type IOrderListItem = IOrder & {
  pickedUpAt?: string | null;
};

@Component({
  name: 'OrderListCommon',
  components: {
    CsvDownloader,
    LockerSearch,
    CommunitySearch,
    BoListPanel,
    BoPanel,
    Datim,
    LockerChip,
    LockerStatusChip,
    OrderChip,
    OrderSearch,
    ServiceProviderChip,
    UserChip,
    CreateButton,
    PaginationBar,
    OrderStatsDashboard,
  }
})
export default class OrderListCommon extends Vue {
  @Prop({default: null})
  private lockerId!: number|null;

  @Prop({default: null})
  private subscriptionId!: number|null;

  @Prop({default: null})
  protected communityScopeId!: number|null;

  @orderModule.Getter('orders')
  private orders!: IOrder[];

  @orderModule.Action('fetchOrders')
  private fetchOrders!: (filters: any) => void;

  @orderModule.Action('clearOrders')
  private clearOrders!: () => void;

  @orderModule.Getter('currentPage')
  currentPage!: number;

  @orderModule.Getter('lastPage')
  lastPage!: number;

  @orderModule.Getter('total')
  total!: number;

  @orderModule.Getter('perPage')
  perPage!: number;

  protected selectedPerPage: number = PAGINATION_DEFAULT_PER_PAGE;
  readonly perPageOptions: number[] = PAGINATION_PER_PAGE_OPTIONS;

  @lockerModule.Action('fetchLockers')
  private fetchLockers!: () => void;

  @lockerModule.Getter('lockers')
  private lockers!: IShortLocker[];

  @communityModule.Getter('communityList')
  private communities!: IShortCommunity[];

  @communityModule.Action('fetchAllCommunities')
  private fetchAllCommunities!: () => void;

  @serviceProviderModule.Getter('serviceProviders')
  private providers!: IShortServiceProvider[];

  @serviceProviderModule.Action('fetchServiceProviders')
  private fetchServiceProviders!: () => void;

  protected remoteFilterFields: string[] = [
    "status",
    "channel",
    "type",
    "grandTotalMax",
    "grandTotalMin",
    "serviceProviderId",
    "paymentStatus",
    "activeFromMin",
    "activeFromMax",
    "createdAtMin",
    "createdAtMax",
    "dueMin",
    "dueMax",
    "confirmed",
    "lockerId",
    "communityId",
    "rentback",
    "discountCode",
    "inLockerOver24h",
    "inLockerOver72h",
    "serviceProviderSubscriptionId",
    "service_provider_subscription_id",
  ];
  protected filtersExpanded: boolean = false;
  protected filterStatus: string[] = [];
  protected filterChannel: string[] = [];
  protected filterType: string[] = [];
  protected grandTotalMax: number|null = null;
  protected grandTotalMin: number|null = null;
  protected serviceProviderId: number = 0;
  protected paymentStatus: string[] = [];
  protected localStorageFilter: string = 'filter';
  protected isFilterActive: boolean = false;
  protected dateMin: string = '';
  protected dateMax: string = '';
  protected dateType: valueDateType = valueDateType['-'];
  protected quickFilter: string|null = null;
  protected filter: filter = {
    status: this.filterStatus,
    channel: this.filterChannel,
    type: this.filterType,
    grandTotalMin: this.grandTotalMin,
    grandTotalMax: this.grandTotalMax,
    serviceProviderId: this.serviceProviderId,
    paymentStatus: this.paymentStatus,
    confirmed: -1,
    lockerId: ALL_LOCKERS_ID,
    communityId: ALL_COMMUNITIES_ID,
    rentback: false,
    discountCode: false,
    inLockerOver24h: false,
    inLockerOver72h: false,
  }

  @authModule.Getter('userData')
  private authUser!: IAuthUserData;

  protected get extraFilters(): object {
    let ret: any = Object.assign({}, this.filter);
    if (this.dateType === valueDateType.active_from) {
      Object.assign(ret, {
        activeFromMin: this.dateMin,
        activeFromMax: this.dateMax,
      });
    } else if (this.dateType === valueDateType.created_at) {
      Object.assign(ret, {
        createdAtMin: this.dateMin,
        createdAtMax: this.dateMax,
      });
    } else if (this.dateType === valueDateType.due) {
      Object.assign(ret, {
        dueMin: this.dateMin,
        dueMax: this.dateMax,
      });
    }
    if (ret.confirmed == -1) {
      delete(ret.confirmed);
    }

    if (this.subscriptionId) {
      ret.serviceProviderSubscriptionId = this.subscriptionId;
      ret.service_provider_subscription_id = this.subscriptionId;
    }

    if (this.communityScopeId !== null) {
      ret.communityId = this.communityScopeId;
    } else if (this.restrictedCommunityId !== null) {
      ret.communityId = this.restrictedCommunityId;
    }

    return ret;
  }

  protected get headers(): BetterDataTableHeader[] {
    return [
      { text: this.$t('common.id'), align: 'start', sortable: true, value: 'id' },
      { text: this.$t('common.type'), align: 'start',sortable: true, value: 'type'},
      { text: this.$t('common.name'), align: 'start', sortable: true, value: 'user' },
      ...(this.communityScopeId === null
        ? [{ text: this.$t('common.community'), align: 'start', sortable: true, value: 'community_id' }]
        : []),
      { text: this.$t('lockers.locker.title'), align: 'start', sortable: true, value: 'locker_id' },
      { text: this.$t('common.serviceProvider'), align: 'start', sortable: true, value: 'service_provider' },
      { text: this.$t('common.status'), align: 'start', sortable: true, value: 'status' },
      { text: this.$t("common.createdAt"), align: 'start', sortable: true, value: 'created_at' },
      { text: this.$t('orders.order.due'), align: 'start', sortable: true, value: 'due' },
      { text: this.$t('orders.order.grand_total'), align: 'start', sortable: true, value: 'grand_total' },
      { text: this.$t('orders.order.pickedUpAt'), align: 'start', sortable: true, value: 'pickedUpAt' },
      { text: "", align: 'center', sortable: false, value: 'action' },
    ];
  }

  protected get canSeeCommunitySelector(): boolean {
    return this.communityScopeId === null && this.restrictedCommunityId === null && this.communities.length > 1;
  }

  // permissions 101/102 (locker owner/operator) scope target_id to a community_id;
  // target_id === 0 means "all communities", so a single non-zero id means the user is locked to it
  protected get restrictedCommunityId(): number | null {
    const permissions = this.authUser.permissions || [];
    const relevant = permissions.filter((p: IAuthUserPermission) =>
      p.permission === EUserPermissions.PERMISSION_LOCKER_OWNER || p.permission === EUserPermissions.PERMISSION_LOCKER_OPERATOR
    );
    if (!relevant.length || relevant.some((p: IAuthUserPermission) => p.target_id === 0)) {
      return null;
    }
    const ids = Array.from(new Set(relevant.map((p: IAuthUserPermission) => p.target_id)));
    return ids.length === 1 ? ids[0] : null;
  }

  private get hasParentLockerId(): boolean {
    // we could make the default null, but we wanted to make a difference between the locker orders and orders
    // (orders let you select a locker, locker orders don't)
    return this.lockerId !== null;
  }

  private get currentLockerId(): number{
    // hasParentLockerId === true ensures that lockerId will be always a number
    return this.hasParentLockerId ? this.lockerId as number : ALL_LOCKERS_ID;
  }

  @Watch('lockerId')
  private updateLockerToParent() {
    this.onLockerSelected(this.currentLockerId);
  }

  @Watch('communities')
  private onCommunitiesLoaded() {
    if (this.communities.length === 1) {
      this.filter.communityId = this.communities[0].id;
    }
  }

  protected onLockerSelected(lockerId: number) {
    this.filter.lockerId = lockerId;
  }

  protected onCommunitySelected(communityId: number) {
    this.filter.communityId = communityId;
  }

  protected get serviceProviderFilter(): any {
    const providers: object = this.providers;
    const newProviders = Object.values(providers)
      .map((each: IShortServiceProvider) => ({
        name: each.name + ` (${each.id})`,
        id: each.id
      }))
      .sort((a, b) => a.name.localeCompare(b.name));
    newProviders.unshift({
      name: '-',
      id: 0,
    });
    return newProviders;
  }

  protected get datesTypes():any {
    const dataType = this.$t("orders.order.dates");
    const newDataType = Object.keys(dataType)
      .map((type) => ({
        text: (dataType as any)[type],
        value: "" + type,
      }))
      .sort((a, b) => a.text.localeCompare(b.text));
    newDataType.unshift({
      text: "-",
      value: "-",
    });
    return newDataType;
  }

  protected get createOrderTo() {
    return { name: 'orderCreate' };
  }

  public created() {
    this.fetchLockers();
    this.fetchServiceProviders();
    if (this.communityScopeId === null && this.restrictedCommunityId === null) {
      this.fetchAllCommunities();
    }
    this.updateLockerToParent();
    if (!this.canSeeAllFilters && this.canSeeFilters) {
      this.dateType = valueDateType.created_at;
    }
  }

  protected loadData() {
    this.fetchLockers();
    this.fetchOrders(this.buildFilters(PAGINATION_FIRST_PAGE));
  }

  private buildFilters(page: number): any {
    const ret: any = Object.assign({}, this.extraFilters);
    ret.page = page;
    ret.perPage = this.selectedPerPage;
    return ret;
  }

  private reload() {
    this.clearOrders();
    this.fetchOrders(this.buildFilters(1));
  }

  protected onPageChange(page: number) {
    this.clearOrders();
    this.fetchOrders(this.buildFilters(page));
  }

  protected onPerPageChange(value: number) {
    this.selectedPerPage = value;
    this.reload();
  }

  @Watch('extraFilters', { deep: true })
  protected onExtraFiltersChanged() {
    this.reload();
  }

  @Watch("filter", { deep: true })
  protected onFilterChanged(newValue: any, oldValue: any) {
    const filterApplied: string | null = localStorage.getItem(this.localStorageFilter);
    if (!filterApplied) { this.isFilterActive = false; return; }
    try {
      const saved = JSON.parse(filterApplied);
      const savedFilter = saved.f !== undefined ? saved.f : saved;
      const current = JSON.stringify(this.filter);
      const old = JSON.stringify(oldValue);
      this.isFilterActive = current === JSON.stringify(savedFilter) || old === JSON.stringify(savedFilter);
    } catch (e) {
      this.isFilterActive = false;
    }
  }

  protected controllerQuickFilter(key: string) {
    this.quickFilter = this.quickFilter === key ? null : key;
    const newFilter: any = this.clearFilter();
    this.dateMin = '';
    this.dateMax = '';
    this.dateType = (!this.canSeeAllFilters && this.canSeeFilters) ? valueDateType.created_at : valueDateType['-'];
    switch (this.quickFilter) {
      case "awaiting_delivery":
        newFilter.status = awaitingDelivery;
        break;
      case "payable":
        newFilter.paymentStatus = payable;
        break;
      case "ready_delivery":
        newFilter.status = orderCompletedReadyDelivery;
        break;
      case "without_package":
        newFilter.type = withoutPackage;
        break;
      case "future_orders":
        newFilter.activeFromMin = futureOrders;
        break;
      case "rentback":
        newFilter.rentback = true;
        break;
      case "discount_code":
        newFilter.discountCode = true;
        break;
      case "completed":
        newFilter.status = ['status_order_completed'];
        break;
      case "delivered":
        newFilter.status = ['status_order_sp_delivered'];
        break;
      case "in_locker_24h":
        newFilter.inLockerOver24h = true;
        this.dateType = valueDateType.created_at;
        this.dateMin = this.dateMinusHours(72);
        this.dateMax = this.dateMinusHours(24);
        break;
      case "in_locker_72h":
        newFilter.inLockerOver72h = true;
        this.dateType = valueDateType.created_at;
        this.dateMax = this.dateMinusHours(72);
        break;
    }
    this.filter = newFilter;
  }

  private dateMinusHours(hours: number): string {
    return new Date(Date.now() - hours * 3600000).toISOString().slice(0, 10);
  }

  protected get hasActiveFilters(): boolean {
    const f = this.filter;
    return !!(
      f.status.length || f.type.length || f.paymentStatus.length ||
      this.quickFilter || f.lockerId !== ALL_LOCKERS_ID ||
      f.grandTotalMin || f.grandTotalMax || f.serviceProviderId ||
      this.dateMin || this.dateMax || f.inLockerOver24h || f.inLockerOver72h ||
      f.communityId !== ALL_COMMUNITIES_ID
    );
  }

  protected get activeFilterCount(): number {
    const f = this.filter;
    let count = 0;
    if (f.status.length) count++;
    if (f.type.length) count++;
    if (f.paymentStatus.length) count++;
    if (this.quickFilter) count++;
    if (f.lockerId !== ALL_LOCKERS_ID) count++;
    if (f.grandTotalMin || f.grandTotalMax) count++;
    if (f.serviceProviderId) count++;
    if (this.dateMin || this.dateMax) count++;
    if (f.inLockerOver24h) count++;
    if (f.inLockerOver72h) count++;
    if (f.communityId !== ALL_COMMUNITIES_ID) count++;
    return count;
  }

  protected quickFilterColor(key: string, selected: boolean = false): string {
    if (selected) {
      if (key === 'completed') return 'green darken-2';
      if (key === 'delivered') return 'teal darken-2';
      if (key === 'in_locker_24h') return 'orange darken-2';
      if (key === 'in_locker_72h') return 'red darken-1';
      return 'blue darken-1';
    }
    if (key === 'completed') return 'green lighten-4';
    if (key === 'delivered') return 'teal lighten-4';
    if (key === 'in_locker_24h') return 'orange lighten-4';
    if (key === 'in_locker_72h') return 'red lighten-4';
    return 'blue lighten-4';
  }

  protected quickFilterTextColor(key: string, selected: boolean = false): string {
    if (selected) return 'white';
    if (key === 'completed') return 'green darken-3';
    if (key === 'delivered') return 'teal darken-3';
    if (key === 'in_locker_24h') return 'orange darken-3';
    if (key === 'in_locker_72h') return 'red darken-3';
    return 'blue darken-3';
  }

  protected toggleFilter(field: 'status' | 'type' | 'paymentStatus', value: string) {
    const current = (this.filter[field] as string[]).slice();
    const idx = current.indexOf(value);
    if (idx >= 0) {
      current.splice(idx, 1);
    } else {
      current.push(value);
    }
    this.filter = Object.assign({}, this.filter, { [field]: current });
  }

  protected clearFilter() {
    return {
      status: [],
      channel: [],
      type: [],
      grandTotalMin: this.grandTotalMin,
      grandTotalMax: this.grandTotalMax,
      serviceProviderId: this.serviceProviderId,
      paymentStatus: [],
      activeFromMin: '',
      lockerId: this.currentLockerId,
      communityId: this.filter.communityId,
      rentback: false,
      discountCode: false,
      inLockerOver24h: false,
      inLockerOver72h: false,
      confirmed: -1,
    };
  }

  protected resetFilters() {
    this.quickFilter = null;
    this.dateMin = '';
    this.dateMax = '';
    this.dateType = (!this.canSeeAllFilters && this.canSeeFilters) ? valueDateType.created_at : valueDateType['-'];
    this.filter = this.clearFilter() as filter;
  }

  protected findLocker(id: number): IShortLocker | {} {
    return this.lockers.find((locker :IShortLocker) => locker.id == id) || {};
  }

  protected linkToOrder(id: number) {
    return {name:'order',params: {orderId:id}};
  }

  protected orderChipStyle(type: string): IChipStyle {
    return OrderChip.chipStyleOf(type);
  }

  protected saveFilter(): void {
    const data = {
      f: this.extraFilters,
      dateMin: this.dateMin,
      dateMax: this.dateMax,
      dateType: this.dateType,
      quickFilter: this.quickFilter,
    };
    localStorage.setItem(this.localStorageFilter, JSON.stringify(data));
    this.$uiBus.emit("success", this.$t('common.filterSaved'));
    this.isFilterActive = false;
  }

  protected showFilterSaved(): any {
    const restoreFilterSaved: string | null = localStorage.getItem(
      this.localStorageFilter
    );
    if (restoreFilterSaved !== null) {
      const saved = JSON.parse(restoreFilterSaved);
      if (saved.f !== undefined) {
        // New format
        this.filter = saved.f;
        this.dateMin = saved.dateMin || '';
        this.dateMax = saved.dateMax || '';
        this.dateType = saved.dateType || ((!this.canSeeAllFilters && this.canSeeFilters) ? valueDateType.created_at : valueDateType['-']);
        this.quickFilter = saved.quickFilter || null;
      } else {
        // Old format (backwards compat): detect date state from the merged filter object
        this.filter = saved;
        this.quickFilter = null;
        if (saved.createdAtMin || saved.createdAtMax) {
          this.dateType = valueDateType.created_at;
          this.dateMin = saved.createdAtMin || '';
          this.dateMax = saved.createdAtMax || '';
        } else if (saved.dueMin || saved.dueMax) {
          this.dateType = valueDateType.due;
          this.dateMin = saved.dueMin || '';
          this.dateMax = saved.dueMax || '';
        } else {
          this.dateType = (!this.canSeeAllFilters && this.canSeeFilters) ? valueDateType.created_at : valueDateType['-'];
          this.dateMin = '';
          this.dateMax = '';
        }
      }
      this.$uiBus.emit("success", this.$t('common.filterApplied'));
      this.filtersExpanded = true;
      this.isFilterActive = true;
    }
  }

  protected gotoOrder(order: IOrder): void {
    this.$router.push({name: 'order', params: { orderId: ''+order.id}});
  }

  protected statusChipLabel(item: IOrderListItem): string {
    const base = '' + this.$t('orders.order.statuses.' + item.status);
    const ageHours = this.pendingPickupAgeHours(item);
    if (ageHours === null || ageHours < 24) {
      return base;
    }
    const ageSuffix = ageHours >= 72
      ? this.$t('orders.order.pendingPickupAgeTags.over72h')
      : this.$t('orders.order.pendingPickupAgeTags.over24h');
    return `${base} ${ageSuffix}`;
  }

  protected statusChipColor(item: IOrderListItem): string | undefined {
    const ageHours = this.pendingPickupAgeHours(item);
    if (ageHours === null || ageHours < 24) {
      return undefined;
    }
    return ageHours >= 72 ? 'red darken-2' : 'orange darken-2';
  }

  protected spikeErrorTitle(item: IOrderListItem): string {
    const err = item.spike_error;
    if (!err) return '';
    return this.$t('orders.order.logs.actions.700') + ': ' + err.operation + ' - ' + err.message;
  }

  private pendingPickupAgeHours(item: IOrderListItem): number | null {
    if (item.status !== EOrderStatuses.status_order_sp_delivered || item.pickedUpAt) {
      return null;
    }
    if (!item.created_at) {
      return null;
    }
    const createdAtMs = new Date(item.created_at).getTime();
    if (Number.isNaN(createdAtMs)) {
      return null;
    }
    return (Date.now() - createdAtMs) / (1000 * 60 * 60);
  }

  private typeChipTitle(order: IOrder): string {
    return order.type
      ? '' + (this.$t("orders.order.types." + (order.type || "office_order")) || this.$t("orders.order.types.unknown"))
      : '';
  }
  

  get canCreate(): boolean {
    return this.$canAction(EPermissionActions.ACTION_ORDERS_CREATE);
  }

  get canSeeFilters(): boolean {
    return this.canSeeAllFilters
      || this.$canAction(EPermissionActions.ACTION_ORDERS_LIMITED_FILTERS_ACCESS);
  }

  get canSeeAllFilters(): boolean {
    return PermissionHelper.hasPermissionAny(this.authUser, EUserPermissions.PERMISSION_ADMINISTRATOR)
      || this.$canAction(EPermissionActions.ACTION_ORDERS_ALL_FILTERS_ACCESS);
  }

  private readonly limitedQuickFilters: string[] = ['delivered', 'in_locker_24h', 'in_locker_72h', 'completed'];

  protected get visibleQuickFilters(): { [key: string]: string } {
    const all = this.$t('orders.order.orderList.quickFilters.filters') as any as { [key: string]: string };
    if (this.canSeeAllFilters) {
      return all;
    }
    const ret: { [key: string]: string } = {};
    this.limitedQuickFilters.forEach((key) => {
      if (all[key]) {
        ret[key] = all[key];
      }
    });
    return ret;
  }

  protected get csvHeaders(): string[] {
    return ['id', 'type', 'user_name', 'user_email', 'locker_id', 'service_provider', 'status', 'created_at', 'due', 'grand_total', 'currency', 'payment_status', 'discount_type', 'discount_code', 'discount_total', 'rentback_amount'];
  }

  protected csvMapRow(item: any): Array<string | number | null | undefined> {
    return [
      item.id,
      item.type || '',
      item.user ? `${item.user.first_name || ''} ${item.user.last_name || ''}`.trim() : '',
      item.user ? item.user.email || '' : '',
      item.locker_id != null ? item.locker_id : '',
      item.service_provider ? item.service_provider.name || '' : '',
      item.status || '',
      item.created_at || '',
      item.due || '',
      item.grand_total || '',
      item.currency || '',
      item.payment_status || '',
      this.csvDiscountType(item),
      item.discount_code || '',
      Number(item.discount_total) > 0 ? item.discount_total : '',
      Number(item.rentback_amount) > 0 ? item.rentback_amount : '',
    ];
  }

  private csvDiscountType(item: any): string {
    const types: string[] = [];
    if (Number(item.rentback_amount) > 0) types.push('rentback');
    if (item.discount_code) types.push('discount_code');
    return types.join(', ');
  }

  protected get csvFileName(): string {
    return this.hasParentLockerId ? 'locker_orders_export.csv' : 'orders_export.csv';
  }

  protected fetchOrdersCsv(): Promise<any[]> {
    return orderService.exportOrders(this.extraFilters);
  }

  protected fetchOrdersCount(): Promise<number> {
    return orderService.fetchOrdersCount(this.extraFilters);
  }

  protected copyLockerName(text: string): void {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(text);
    } else {
      const el = document.createElement('textarea');
      el.value = text;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }
  }

}

